import { posts, rankings } from '@/mocks/entertainment';

function trendIcon(t: 'up' | 'down' | 'flat') {
  if (t === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-primary-500' };
  if (t === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-accent-600' };
  return { icon: 'ri-subtract-line', cls: 'text-foreground-400' };
}

const pick = posts[11]; // 演唱会大图

export default function RankingSection() {
  return (
    <section id="hotlist" className="mx-auto max-w-7xl px-4 md:px-6 pt-16 md:pt-24">
      <div className="rounded-3xl bg-foreground-950 text-background-50 p-6 md:p-10 relative overflow-hidden">
        <div className="absolute -top-16 -right-10 text-background-50/5 font-display text-[180px] leading-none select-none">瓜</div>
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 relative">
          <div className="lg:w-[58%]">
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-bold tracking-widest text-accent-400">TOP 10 · 全网热度实时榜单</p>
              <span className="flex items-center gap-1.5 text-xs text-background-300">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>更新于刚刚
              </span>
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-black">今日热榜 · 全网在聊什么</h3>
            <ol className="mt-6 space-y-1">
              {rankings.map((r, i) => {
                const t = trendIcon(r.trend);
                return (
                  <li key={r.id}>
                    <a href="#realtime" className="group flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-background-50/5 transition">
                      <span className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-lg text-sm font-black ${
                        i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-50/10 text-background-200'
                      }`}>{r.id}</span>
                      <span className="flex-1 text-sm md:text-[15px] text-background-100 group-hover:text-accent-300 line-clamp-1 min-w-0">{r.title}</span>
                      <span className={`hidden md:flex items-center gap-1 text-xs ${t.cls}`}>
                        <i className={t.icon}></i>{r.heat}
                      </span>
                    </a>
                  </li>
                );
              })}
            </ol>
          </div>

          <aside className="lg:w-[42%] flex flex-col gap-4">
            <div className="relative rounded-2xl overflow-hidden min-h-[240px] flex-1">
              <img src={pick.image} alt="姜予洲巡回演唱会现场" className="absolute inset-0 w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">主编荐读</span>
                <h4 className="mt-2 text-lg font-bold leading-snug text-background-50">姜予洲巡回演唱会：票为什么这么难抢？</h4>
              </div>
            </div>
            <div className="rounded-2xl bg-background-50/10 border border-background-50/15 p-5">
              <h5 className="text-sm font-bold text-accent-300 flex items-center gap-2"><i className="ri-quill-pen-line"></i>编辑说</h5>
              <p className="mt-2 text-sm leading-relaxed text-background-200">
                榜单不代表站队，只代表此刻的真实热度。想看完整脉络，欢迎顺着「实时速递」把每一环吃透。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}